/* PureWoven "What's my size?" quiz.
   Recommends a legging size from height + weight + fit preference.
   Bands are height-adjusted weight (lbs) at a 5'3" reference, calibrated
   from PureWoven wear tests and cross-checked against industry charts. */

(function () {
  var REF_HEIGHT_IN = 63; /* 5'3" reference */
  var LBS_PER_INCH = 3; /* weight allowance per inch of height */
  var EDGE_LBS = 4; /* within this of a band edge = "between sizes" */

  /* Industry consensus bands (Blanqi/Spanx/self-reported, 5'4" ref)
     shifted one size roomier per PureWoven wear tests: 115lb @ 5'3"
     fits XXS(0); 122lb @ 5'3" fits XS(2). */
  var SIZES = [
    { letter: 'XXS', us: 0, max: 117 },
    { letter: 'XS', us: 2, max: 127 },
    { letter: 'S', us: 4, max: 138 },
    { letter: 'M', us: 6, max: 150 },
    { letter: 'L', us: 8, max: 163 },
    { letter: 'XL', us: 10, max: 177 },
    { letter: 'XXL', us: 12, max: Infinity },
  ];

  function computeSize(heightIn, weightLbs, fitShift) {
    var adj = weightLbs - LBS_PER_INCH * (heightIn - REF_HEIGHT_IN);
    var idx = SIZES.findIndex(function (s) { return adj <= s.max; });
    if (idx === -1) idx = SIZES.length - 1;

    var between = null;
    if (idx > 0 && adj - (SIZES[idx - 1].max) <= EDGE_LBS && adj > SIZES[idx - 1].max) {
      between = 'lower';
    } else if (idx < SIZES.length - 1 && SIZES[idx].max - adj <= EDGE_LBS) {
      between = 'upper';
    }

    idx = Math.max(0, Math.min(SIZES.length - 1, idx + fitShift));
    return { size: SIZES[idx], index: idx, between: between, adjusted: adj };
  }

  /* expose for testing */
  window.pwComputeSize = computeSize;

  if (customElements.get('pw-size-quiz')) return;

  customElements.define(
    'pw-size-quiz',
    class PwSizeQuiz extends HTMLElement {
      connectedCallback() {
        this.modal = this.querySelector('.pw-quiz__modal');
        this.overlay = this.querySelector('.pw-quiz__overlay');
        this.metric = false;
        this.fitShift = 0;

        this.addEventListener('click', this.onClick.bind(this), true);
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') this.close();
        }.bind(this));

        /* trigger is server-rendered in the size label row */
        var self = this;
        document.addEventListener('click', function (e) {
          if (e.target.closest('[data-quiz-open]')) self.open();
        }, true);
      }

      onClick(e) {
        var t = e.target;
        if (t.closest('[data-quiz-close]')) return this.close();
        if (t.closest('[data-quiz-next]')) return this.toStep2();
        if (t.closest('[data-quiz-back]')) return this.showStep('1');
        if (t.closest('[data-quiz-restart]')) return this.showStep('1');
        var unitBtn = t.closest('[data-quiz-unit]');
        if (unitBtn) return this.setUnits(unitBtn.getAttribute('data-quiz-unit'));
        var fitBtn = t.closest('[data-quiz-fit]');
        if (fitBtn) return this.finish(parseInt(fitBtn.getAttribute('data-quiz-fit'), 10));
        if (t.closest('[data-quiz-select]')) return this.selectOnPage();
      }

      open() {
        this.modal.hidden = false;
        this.overlay.hidden = false;
        document.documentElement.classList.add('pw-quiz-open');
        this.showStep('1');
        var first = this.modal.querySelector('select, input');
        if (first) first.focus();
      }

      close() {
        if (!this.modal) return;
        this.modal.hidden = true;
        this.overlay.hidden = true;
        document.documentElement.classList.remove('pw-quiz-open');
      }

      showStep(name) {
        this.querySelectorAll('.pw-quiz__step').forEach(function (s) {
          s.hidden = s.getAttribute('data-step') !== name;
        });
        var err = this.querySelector('[data-quiz-error]');
        if (err) err.hidden = true;
      }

      setUnits(mode) {
        this.metric = mode === 'metric';
        this.querySelectorAll('[data-quiz-unit]').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-quiz-unit') === mode);
        }.bind(this));
        this.querySelector('[data-imperial]').hidden = this.metric;
        this.querySelector('[data-metric]').hidden = !this.metric;
      }

      readInputs() {
        var heightIn, weightLbs;
        if (this.metric) {
          var cm = parseFloat(this.querySelector('[data-quiz-cm]').value);
          var kg = parseFloat(this.querySelector('[data-quiz-kg]').value);
          heightIn = cm / 2.54;
          weightLbs = kg * 2.20462;
        } else {
          var ft = parseInt(this.querySelector('[data-quiz-ft]').value, 10);
          var inch = parseInt(this.querySelector('[data-quiz-in]').value, 10);
          heightIn = ft * 12 + inch;
          weightLbs = parseFloat(this.querySelector('[data-quiz-lbs]').value);
        }
        return { heightIn: heightIn, weightLbs: weightLbs };
      }

      toStep2() {
        var v = this.readInputs();
        var err = this.querySelector('[data-quiz-error]');
        if (
          !isFinite(v.heightIn) || !isFinite(v.weightLbs) ||
          v.heightIn < 54 || v.heightIn > 78 ||
          v.weightLbs < 70 || v.weightLbs > 350
        ) {
          if (err) err.hidden = false;
          return;
        }
        if (err) err.hidden = true;
        this.inputs = v;
        this.showStep('2');
      }

      finish(fitShift) {
        this.fitShift = fitShift || 0;
        var v = this.inputs || this.readInputs();
        var r = computeSize(v.heightIn, v.weightLbs, this.fitShift);
        this.result = r;

        this.querySelector('[data-quiz-size]').textContent = r.size.letter;
        this.querySelector('[data-quiz-us]').textContent = 'US ' + r.size.us;

        var notes = [];
        if (r.between === 'upper' && r.index < SIZES.length - 1) {
          notes.push("You're near the edge of " + SIZES[r.index + 1].letter + ' — size up if you prefer a softer fit.');
        } else if (r.between === 'lower' && r.index > 0) {
          notes.push("You're near the edge of " + SIZES[r.index - 1].letter + ' — size down for extra compression.');
        }
        if (v.heightIn <= 62) {
          notes.push('Petite note: the 25⅞" inseam lands as a clean full-length fit on you.');
        } else if (v.heightIn >= 69) {
          notes.push('Tall note: expect a chic above-the-ankle crop.');
        }
        this.querySelector('[data-quiz-note]').textContent = notes.join(' ');

        var cta = this.querySelector('[data-quiz-select]');
        var radio = this.findSizeRadio(r.size.letter);
        cta.hidden = !radio;
        if (radio) cta.textContent = 'Select size ' + r.size.letter;

        this.showStep('result');
      }

      findSizeRadio(letter) {
        var radios = document.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          if (
            radios[i].value.trim().toUpperCase() === letter &&
            /size/i.test(radios[i].name || '')
          ) {
            return radios[i];
          }
        }
        return null;
      }

      selectOnPage() {
        var radio = this.findSizeRadio(this.result.size.letter);
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          radio.dispatchEvent(new Event('input', { bubbles: true }));
        }
        this.close();
      }
    }
  );
})();
